<template>
  <div
    :class="['button', 'button--' + type, 'button--' + type + '--' + size, 'button--' + variant, 'button--' + color]"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'text',
      validator (values) {
        return ['text', 'icon'].includes(values)
      }
    },
    size: {
      type: String,
      default: 'normal',
      validator (values) {
        return ['small', 'normal', 'large'].includes(values)
      }
    },
    variant: {
      type: String,
      default: 'normal',
      validator (values) {
        return ['normal', 'borderless'].includes(values)
      }
    },
    color: {
      type: String,
      default: 'blue',
      validator (values) {
        return ['blue', 'green', 'yellow', 'orange', 'pink', 'purple', 'inactive'].includes(values)
      }
    },
    highlightColor: {
      type: String,
      default: '#1b1e21'
    },
    activeColor: {
      type: String,
      default: '#1593a6'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.button {
  &--text {
    @include font('content--sm', $white, 0.8);
    text-transform: uppercase;
    letter-spacing: 0.025rem;
    border: 2px solid rgba($black, 0);
    border-radius: 999px;
    padding: 0.1rem 1rem;
    margin: 0.25rem;
    transition: color 0.2s ease-in-out, background-color 0.2s ease-in-out, border 0.2s ease-in-out;
    user-select: none;
    cursor: pointer;
  }

  &--icon {
    display: inline-block;
    position: relative;
    z-index: 1;
    background-color: $bg-3;
    cursor: pointer;
    padding: 8px;
    margin: 6px;
    border-radius: 50%;
    transition: fill 0.2s, background-color 0.2s;
    fill: $white;

    &--small {
      width: 14px;
      height: 14px;
    }

    &--normal {
      width: 18px;
      height: 18px;
    }

    &--large {
      width: 24px;
      height: 24px;
    }

    &:after {
      top: -4px;
      left: -4px;
      padding: 4px;
      box-shadow: 0 0 0 3px $bg-3;
      transition: transform 0.2s, opacity 0.2s;
      transform: scale(0.8);
      opacity: 0;
      pointer-events: none;
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      content: '';
      box-sizing: content-box;
    }

    &:hover {
      background: $bg-3;
      fill: $blue;
    }

    &:hover:after {
      transform: scale(1);
      opacity: 1;
    }

    &:active, &:focus {
      background: rgba($bg-3, 0.5);
      fill: $white;
    }

    &:active:after, &:focus:after {
      box-shadow: 0 0 0 3px rgba($bg-3, 0.5);
    }
  }

  &--borderless {
    border-color: rgba($black, 0) !important;
  }

  &--blue {
    &.button--text {
      border-color: rgba($blue, 0.5);

      &:hover {
        background-color: rgba($blue, 0.1); //darken($blue, 15%);
        border-color: $blue;
        color: $white;
      }

      &:active {
        background-color: darken($blue, 20%);
        color: $white;
      }
    }
  }

  &--green {
    &.button--text {
      border-color: rgba($green, 0.5);

      &:hover {
        background-color: rgba($green, 0.1); //darken($green, 15%);
        border-color: $green;
        color: $white;
      }

      &:active {
        background-color: darken($green, 20%);
        color: $white;
      }
    }
  }

  &--inactive {
    user-select: none;
    pointer-events: none;
    &.button--text {
      border-color: rgba($bg-3, 0.5);
      color: $bg-3;
    }
  }
}
</style>
